import { call, put, select } from 'redux-saga/effects'
import {
  requestBroadcastNotification,
  getScheduledNotification,
  getProductListByProductIds,
  deleteScheduledNotification,
  postScheduleNotification,
  updateScheduledNotification,
  requestBroadcastUserNotification,
  getRecieverCount,
  getNotificationReport,
  getBulkNotification
} from '../requests/notificationService'
import {
  setProcessing,
  setSuccess,
  setNotification,
  setProductLoading,
  setProductList,
  setNotificationLoading,
  setNotificationCount,
  setRedirect,
  setNotificationCountLoading,
} from '../../slices/notificationSlice'
import { toast } from 'react-toastify'
import { setAppLoading } from 'redux/slices/authTokenSlice'
import {
  setNotificationReport,
  setNotificationLoading as reportLoading,
} from '../../slices/notificationReportSlice.js'

export function* handleBroadCastNotification(action) {
  const { payload, isUserNotification = false } = action.payload
  try {
    yield put(setProcessing())
    let response
    if (isUserNotification) {
      response = yield call(() => requestBroadcastNotification(payload))
    } else {
      response = yield call(() => requestBroadcastUserNotification(payload))
    }
    yield put(setSuccess(response.data.message))
    toast.success(
      `${payload.type === 'app_notification' ? 'App' : 'Sms'
      } Notification Sent`,
    )
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handleGetScheduledNotification(action) {
  try {
    const { type, status, notification_type, page } = action.payload
    yield put(setNotificationLoading())
    const { data: notification } = yield call(() =>
      getScheduledNotification(type, status, notification_type, page),
    )
    yield put(
      setNotification({
        data: notification.data,
        hasNext: notification.has_next,
        hasPrev: notification.has_prev,
        page: notification.page_no,
        totalPage: notification.total_pages,
      }),
    )
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    yield put(
      setNotification({
        error: errMsg,
      }),
    )
  }
}

export function* handleGetProductListByProductIds(action) {
  try {
    yield put(setProductLoading())
    const { data } = yield call(() =>
      getProductListByProductIds(action.payload),
    )
    yield put(setProductList(data))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
    yield put(setProductLoading(false))
  }
}

export function* handleDeleteNotification(action) {
  try {
    yield put(setProcessing())
    const {
      scheduled: { data },
    } = yield select((state) => state.notification)
    yield call(() => deleteScheduledNotification(action.payload))
    yield put(
      setNotification({ data: data.filter((d) => d.id !== action.payload) }),
    )
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handleScheduleNotification(action) {
  const notificationPayload = action.payload
  try {
    yield put(setProcessing())
    const response = yield call(() =>
      postScheduleNotification(notificationPayload),
    )
    yield put(setSuccess(response.data.message))
    toast.success(
      `${notificationPayload.type === 'app_notification' ? 'App' : 'Sms'
      } Notification Scheduled`,
    )
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handleUpdateScheduleNotification(action) {
  try {
    yield put(setProcessing())
    const { id, payload } = action.payload
    const {
      scheduled: { data },
    } = yield select((state) => state.notification)
    const resp = yield call(() => updateScheduledNotification(id, payload))
    yield put(
      setNotification({
        data: data.map((d) => {
          if (d.id === id) {
            return resp.data
          } else {
            return d
          }
        }),
      }),
    )
    toast.success(
      `${payload.type === 'app_notification' ? 'App' : 'Sms'
      } Notification Updated`,
    )
    yield put(setRedirect(true))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  } finally {
    yield put(setSuccess('updated'))
    yield put(setProcessing(false))
  }
}

export function* handleGetReceiverCount(action) {
  try {
    yield put(setAppLoading(true))
    yield put(setNotificationCountLoading(true))
    const response = yield call(() => getRecieverCount(action.payload))
    yield put(setNotificationCount(response.data))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    toast.error(errMsg)
  } finally {
    yield put(setAppLoading(false))
  }
}

export function* handleGetNotificationReport(action) {
  try {
    const { page, dateFrom, dateTo, type} = action.payload
    yield put(reportLoading())
    const { data: notification } = yield call(() =>
      getNotificationReport(page, dateFrom, dateTo, type),
    )
    yield put(
      setNotificationReport({
        data: notification.data,
        hasNext: notification.has_next,
        hasPrev: notification.has_prev,
        page: notification.page,
        totalPage: notification.total_pages,
      }),
    )
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    yield put(setNotificationReport({ error: errMsg }))
  }
}

export function* handleGetBulkNotification(action) {
  try {
    const { type, status, notification_type, page } = action.payload
    yield put(setNotificationLoading())
    const { data: notification } = yield call(() =>
      getBulkNotification(type, status, notification_type, page),
    )
    yield put(
      setNotification({
        data: notification.data,
        hasNext: notification.has_next,
        hasPrev: notification.has_prev,
        page: notification.page,
        totalPage: notification.total_pages,
      }),
    )
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message
    yield put(
      setNotification({
        error: errMsg,
      }),
    )
  }
}


